import React, { Component } from 'react';
import * as svgSources from './ReactErrorSvg'

class ReactError extends Component {

  constructor(props) {
    super(props);
  }

  render() {
    const {
      color, height, width, ...restProps
    } = this.props;

    const style = {
      fill: color,
      height,
      width,
    };

    const selectedType = this.props.type || 'cancel';
    const svg = svgSources[selectedType];

    return (
      <div
        style={style}
        dangerouslySetInnerHTML={{ __html: svg }}
        {...restProps}
      />
    );
  }
}

export default ReactError;
